import { createListCollection, Field, Spinner, Stack, Text } from "@chakra-ui/react";

import { SelectContent, SelectItem, SelectRoot, SelectTrigger, SelectValueText } from "../ui/select";

export interface Item {
  label: string | React.JSX.Element;
  value: string;
  disabled?: boolean;
}

interface SelectWithClearProps {
  options: Item[];
  title?: string;
  isLoading?: boolean;
  onChange: (value: string | undefined) => void;
  onClear?: () => void;
  value: string | undefined;
  bg?: string;
  size?: "sm" | "md" | "lg" | "xs" | undefined;
  placeholder?: string;
  clearable?: boolean;
  zIndex?: string;
  width?: string;
  titleFontSize?: string;
}

//THE SELECT COMPONENT USED FOR THIS SUPPORTS MULTIPLE SELECTION. THIS IMPLEMENTATION ONLY SUPPORTS SINGLE SELECTION
// TO DO A SIMILAR COMPONENT THAT HANDLE ONLY MULTIPLE SELECTION
const AppSelect: React.FC<SelectWithClearProps> = ({
  options,
  title,
  onChange,
  onClear,
  value,
  isLoading,
  bg,
  size = "sm",
  placeholder = "",
  clearable = true,
  zIndex = "dropdown",
  width,
  titleFontSize = "sm",
}) => {
  const optionCollection = createListCollection({ items: options });

  return (
    <Field.Root mr={title ? "2%" : "0"} p={title ? "inherit" : "0"} m={title ? "inherit" : "0"} width={width}>
      {title && (
        <Text as="b" fontSize={titleFontSize}>
          {title}
        </Text>
      )}
      <Stack gap={title ? "inherit" : "0"} width="100%">
        {isLoading ? (
          <Spinner />
        ) : (
          <SelectRoot
            collection={optionCollection}
            size={size}
            onValueChange={e => {
              onChange(e.items[0] ? e.items[0].value : undefined);
            }}
            value={value ? [value] : undefined}
          >
            <SelectTrigger clearable={clearable} bg={bg} rounded={"md"} onClear={onClear}>
              <SelectValueText placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent bg={bg} zIndex={zIndex} minW="max-content" w="auto">
              {optionCollection.items.map(x => (
                <SelectItem item={x} key={x.value}>
                  {x.label}
                </SelectItem>
              ))}
            </SelectContent>
          </SelectRoot>
        )}
      </Stack>
    </Field.Root>
  );
};

export default AppSelect;
